import React from "react";
import Navbar from "../../components/navbar";
import "./profileView.css";

export default function profileView() {
  return (
    <div className="view">
      <Navbar />
      <div className="profile-view">
        under construction
      </div>
    </div>
  );
}
